import React, { useState, useEffect } from 'react';
import {  
  Toolbar, 
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  Paper,
  Box,
  Stack,
  styled,
  useTheme,
  LinearProgress,
  Chip
} from '@mui/material';
import AdminDashboard from './AdminDashboard';

const drawerWidth = 240;


const MetricCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[4]
  },
  position: 'relative',
  overflow: 'visible',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 4,
    background: theme.palette.primary.main,
    opacity: 0.3
  }
}));




const AdminContent = () => {
  const theme = useTheme();
  const [mode, setMode] = useState(() => {
    const savedMode = localStorage.getItem('themeMode');
    return savedMode || 'light';
  });
  const [open, setOpen] = useState(true);
  const [metrics, setMetrics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => setMode(mediaQuery.matches ? 'dark' : 'light');
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);



  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        await new Promise(resolve => setTimeout(resolve, 1000));
        setMetrics([
          { title: 'Total Users', value: '24,530', positive: true },
          { title: 'Revenue', value: '$45,200', positive: true },
          { title: 'Orders', value: '1,230',  positive: false },
          { title: 'Active Sessions', value: '892',  positive: true },
          { title: 'Conversion Rate', value: '3.2%',  positive: true },
          { title: 'Avg. Order Value', value: '$86', positive: false },
          { title: 'Pending Orders', value: '56', positive: true },
          { title: 'Support Tickets', value: '23',  positive: false },
          { title: 'Products', value: '1,450',  positive: true },
          { title: 'Monthly Visits', value: '89.4K', positive: true },
        ]);
      } catch (error) {
        console.error('Error fetching metrics:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, []);


  return (
  <>
  <AdminDashboard>
        {/* Main Content */}
        <Box component="main" sx={{ 
          flexGrow: 1, 
          p: 3,
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          marginLeft: `-${drawerWidth}px`,
          ...(open && {
            transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
          }),
        }}>
          {/* <Toolbar /> */}
          
          {loading ? (
            <LinearProgress sx={{ width: '100%', marginTop:"-30px" }} />
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} lg={8}>
                <Grid container spacing={2}>
                  {metrics.map((metric, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <MetricCard>
                        <CardContent>
                          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            {metric.title}
                          </Typography>
                          <Stack direction="row" alignItems="center" >
                            <Typography variant="h5" fontWeight={600}>
                              {metric.value}
                            </Typography>
                           
                          </Stack>
                        </CardContent>
                      </MetricCard>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid item xs={12} lg={4}>
                <Paper sx={{ 
                  p: 3, 
                  height: '100%',
                  bgcolor: 'background.paper',
                  boxShadow: theme.shadows[2],
                  borderRadius: 2
                }}>
                  <Stack spacing={2}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Avatar 
                        src="/profile.jpg"
                        sx={{ 
                          width: 88, 
                          height: 88, 
                          mb: 2,
                          border: `2px solid ${theme.palette.primary.main}`,
                          mx: 'auto'
                        }}
                      />
                      <Typography variant="h6" gutterBottom>
                        John Doe
                      </Typography>
                      <Chip 
                        label="Administrator" 
                        size="small" 
                        color="primary"
                        sx={{ mb: 2, fontWeight: 500 }}
                      />
                      <LinearProgress 
                        variant="determinate" 
                        value={75} 
                        sx={{ height: 6, borderRadius: 3, mb: 2 }}
                        color="primary"
                      />
                      <Typography variant="caption" color="text.secondary">
                        Profile Completeness: 75%
                      </Typography>
                    </Box>
                    <Divider />
                    
                    <Box>
                      <InfoRow label="Email" value="john@example.com" />
                      <InfoRow label="Phone" value="+1 234 567 890" />
                      <InfoRow label="Location" value="New York, USA" />
                      <InfoRow label="Department" value="Management" />
                      <InfoRow label="Last Login" value="2 hours ago" />
                    </Box>
                  </Stack>
                </Paper>
              </Grid>
            </Grid>
          )}
        </Box>
        </AdminDashboard>
        </>

  );
}

const InfoRow = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" py={1}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={500}>
      {value}
    </Typography>
  </Stack>
);

export default AdminContent;